import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { GlobalPrivateState, plateBuilder } from 'src/api';

export interface PricingsDispatcherProps {
  dispatch: Function;
}

const dispatchKey = 'pricings';

class PricingsDispatcherContainer extends React.Component<PricingsDispatcherProps> {
  componentDidMount() {
    this.dispatchPricing();
  }

  public render() {
    return null;
  }

  private dispatchPricing() {
    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url: `/Pricings/`
      },
      true
    ));
  }
}


export const PricingsDispatcher = connect((state: GlobalPrivateState) => ({
}))(PricingsDispatcherContainer);
